import React from "react";
import Typography from "@mui/material/Typography";

const PageTitle = props => {

	const { title, ...rest } = props;

	return (
		<Typography component="h1" variant="h1" sx={{ pb: "34px" }} {...rest}>
			{title}
		</Typography>
	);
};

export default PageTitle;